"use client";

import urls from "@/utils/urls/urls";
import Link from "next/link";
import React, { useEffect } from "react";
import { useState } from "react";
import { Offcanvas } from "react-bootstrap";

export default function NavbarMobile({ propsData }: any) {
  const { menuData, settings, dataProductCategory } = propsData;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  // console.log("settings", settings)

  function useNavbarScroll() {
    useEffect(() => {
      const navbar = document.querySelector(".navbar");
      const navbarContainer = document.querySelector(".navbar-container");
      // console.log("navbar", navbar)

      const handleScroll = () => {
        if (window.scrollY > 100) {
          navbar?.classList.remove("position-relative");
          navbar?.classList.add("position-fixed");
          navbarContainer?.classList.add("nav-width-100");
          navbarContainer?.classList.remove("nav-width-80");
        } else {
          navbar?.classList.remove("position-fixed");
          navbar?.classList.remove("position-relative");
          navbarContainer?.classList.remove("nav-width-100");
          navbarContainer?.classList.add("nav-width-80");
        }
      };

      window.addEventListener("scroll", handleScroll);

      // Cleanup
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  }

  useNavbarScroll();

  return (
    <>
      <div className="main-navigation ">
        <nav className="navbar navbar-expand-lg navbar-container">
          <div className="container position-relative navbar-container">
            <Link className="navbar-brand" href="/">
              {/* <img src="../assets/img/logo/logo.png" alt="logo" /> */}
              {/* <img src={`${urls?.image}${footerData?.logo}`} alt="logo" /> */}
              <img
                src={`${urls?.root}${settings?.logo_image}`}
                alt="logo"
                style={{
                  width: "250px",
                }}
              />
            </Link>
            <div className="mobile-menu-right">
              <div className="mobile-menu-btn">
                {/* <button
                                            type="button"
                                            className="nav-right-link search-box-outer"
                                        >
                                            <i className="far fa-search" />
                                        </button> */}
              </div>
              {/* menu btn  mbtn*/}
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasNavbar"
                aria-controls="offcanvasNavbar"
                aria-label="Toggle navigation"
                onClick={() => setIsDrawerOpen(true)}
              >
                <span />
                <span />
                <span />
              </button>
            </div>
            <div
              className="offcanvas offcanvas-start"
              tabIndex={-1}
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
            >
              <div className="offcanvas-header">
                <Link
                  href="/"
                  className="offcanvas-brand"
                  id="offcanvasNavbarLabel"
                >
                  <img src="../assets/img/logo/logo.png" alt="" />
                </Link>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <i className="far fa-xmark" />
                </button>
              </div>
              <div className="offcanvas-body">
                <ul className="navbar-nav justify-content-end flex-grow-1">
                  {menuData?.menu_items?.map((menuItem: any, index: any) => (
                    <li key={index} className="navbar-dropdown nav-item">
                      <Link href={menuItem.url_slug} className="nav-link">
                        {menuItem?.menu_level}
                      </Link>
                      {menuItem?.subMenuItems?.length > 0 && (
                        <div className="dropdown dropdown-menu">
                          {menuItem?.subMenuItems?.map(
                            (subItem: any, subIndex: any) => {
                              if (menuItem?.menu_level === "Products") {
                                return (
                                  <Link
                                    key={subIndex}
                                    href={subItem?.url_slug}
                                    className="dropdown-item"
                                  >
                                    {subItem?.menu_level}
                                  </Link>
                                );
                              }
                              return (
                                <Link
                                  key={subIndex}
                                  href={subItem?.url_slug}
                                  className="dropdown-item"
                                >
                                  {subItem?.menu_level}
                                </Link>
                              );
                            },
                          )}
                        </div>
                      )}
                    </li>
                  ))}
                  {/* react */}

                  {/* react end */}

                  {/* <li className="nav-item">
                                                <Link className="nav-link" href="contact">
                                                    Contact
                                                </Link>
                                            </li> */}
                </ul>
                {/* nav-right */}
                <div className="nav-right">
                  {/* <div className="search-btn">
                                                <button
                                                    type="button"
                                                    className="nav-right-link search-box-outer"
                                                >
                                                    <i className="far fa-search" />
                                                </button>
                                            </div> */}
                  {/* <div className="shop-cart">
                              <Link href="shop-cart" className="nav-right-link"><i className="far fa-shopping-bag"></i><span>0</span></Link>
                          </div> */}
                  <div className="nav-btn">
                    <Link href="contact" className="theme-btn nav-theme-btn">
                      Let's Talk
                      <i className="fas fa-arrow-right" />
                    </Link>
                  </div>
                  <div
                    style={{
                      opacity: 0,
                      // border: '1px solid red'
                    }}
                  >
                    <button
                      type="button"
                      className="sidebar-btn nav-right-link"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#sidebarPopup"
                    >
                      <span />
                      <span />
                      <span />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <DrawerWrapper
        show={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="My Drawer"
        brand={settings?.logo_image}
      >
        <ul className="menu-list">
          {menuData?.menu_items &&
            menuData?.menu_items.map((menuItem: any, index: any) => (
              <li key={index} style={{ margin: "0px", padding: "0px" }}>
                {menuItem?.subMenuItems?.length > 0 ? (
                  <>
                    <Link
                      href={menuItem?.url_slug}
                      className="drop-down fs-6"
                      style={{ textDecoration: "none" }}
                      onClick={() => setIsDrawerOpen(false)} // ✅ Close on click
                    >
                      {menuItem?.menu_level}{" "}
                      <span className="plus-animation"></span>
                    </Link>

                    <ul className="sub-menu">
                      {menuItem?.subMenuItems &&
                        menuItem?.subMenuItems.map(
                          (subItem: any, subIndex: any) => (
                            <li key={subIndex}>
                              {/* <ul> */}
                              <Link
                                href={subItem?.url_slug}
                                style={{ textDecoration: "none" }}
                                onClick={() => setIsDrawerOpen(false)} // ✅ Close on click
                              >
                                <li>&nbsp;&nbsp;&nbsp;{subItem?.menu_level}</li>
                              </Link>
                              {/* </ul> */}
                            </li>
                          ),
                        )}
                    </ul>
                  </>
                ) : (
                  <Link
                    href={menuItem?.url_slug}
                    style={{ textDecoration: "none" }}
                    onClick={() => setIsDrawerOpen(false)} // ✅ Close on click
                  >
                    {menuItem?.menu_level}
                  </Link>
                )}
              </li>
            ))}
        </ul>
      </DrawerWrapper>
    </>
  );
}

const DrawerWrapper = ({
  show,
  onClose,
  title = "Drawer",
  placement = "start",
  children,
  brand: brandLogo,
}: any) => {
  // console.log(`${urls?.root}${brandLogo}`)
  return (
    <Offcanvas show={show} onHide={onClose} placement={placement}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <Link href={"/"}>
            <img
              src={`${urls?.root}${brandLogo}`}
              alt="Logo"
              className=""
              style={{
                width: "250px",
                height: "auto",
                padding: "5px",
                marginLeft: "10px",
                borderRadius: "4px",
                // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
              }}
            />
          </Link>
          {/* {title} */}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>{children}</Offcanvas.Body>
    </Offcanvas>
  );
};
